"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDownModule = void 0;
var tracker_service_1 = require("@src/services/tracker.service");
var cash_dom_1 = __importDefault(require("cash-dom"));
var object_service_1 = require("../../services/object-service");
var settings_service_1 = require("../../services/settings.service");
var dropdown_helper_1 = require("./helpers/dropdown.helper");
var dropdown_model_1 = require("./models/dropdown.model");
var DropDownModule = /** @class */ (function () {
    function DropDownModule() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.trackerService = object_service_1.ObjectService.getInstance(tracker_service_1.TrackerService);
        this.replayingStudioSelectionChange = false;
    }
    DropDownModule.prototype.sendForm = function () {
        throw new Error('Method not implemented.');
    };
    DropDownModule.prototype.loadModule = function (attributes) {
        return __awaiter(this, void 0, void 0, function () {
            var settings, dropdownType, containerType, dataSet, dropdownOptions, _i, dropdownOptions_1, element;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        settings = attributes.attributeHandlers;
                        console.log('Loading dropdown with settings:', settings, 'container:', this.$container, 'module:', this.module, "so the type is", this.$container.data("type"));
                        dropdownType = this.$container.data("type");
                        if (!dropdownType) {
                            console.error("Unset dropdown type, make sure to set data-type='' to the correct value");
                            return [2 /*return*/];
                        }
                        containerType = this.$container.prop('tagName');
                        if (containerType !== 'SELECT') {
                            console.error('dropdown module has to be inside a SELECT, make sure you use a select-field and not a', containerType);
                            return [2 /*return*/];
                        }
                        if (dropdownType === dropdown_model_1.dropdownPreset.studioLocation) {
                            this.awaitStudioSelectionTracking();
                        }
                        dataSet = this.$container.data('set');
                        if (dataSet) {
                            this.$container.on('change', function (event) {
                                var selectedValue = (0, cash_dom_1.default)(event.target).val();
                                localStorage.setItem(dataSet, selectedValue);
                            });
                        }
                        return [4 /*yield*/, (0, dropdown_helper_1.generateDropdown)(dropdownType, this.config)];
                    case 1:
                        dropdownOptions = _a.sent();
                        for (_i = 0, dropdownOptions_1 = dropdownOptions; _i < dropdownOptions_1.length; _i++) {
                            element = dropdownOptions_1[_i];
                            this.$container.append(element);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DropDownModule.prototype.awaitStudioSelectionTracking = function () {
        var _this = this;
        var _a;
        (_a = this.$container.get(0)) === null || _a === void 0 ? void 0 : _a.addEventListener('change', function (event) { return __awaiter(_this, void 0, void 0, function () {
            var e_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.replayingStudioSelectionChange)
                            return [2 /*return*/];
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.trackerService.trackFunnelEvent(this.config, 'studioSelected')];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        console.error('studioSelected tracking failed', e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.replayingStudioSelectionChange = true;
                        (_a = this.$container.get(0)) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new Event('change', { bubbles: true }));
                        this.replayingStudioSelectionChange = false;
                        return [2 /*return*/];
                }
            });
        }); }, true);
    };
    return DropDownModule;
}());
exports.DropDownModule = DropDownModule;
